import { Button } from '@rocketlane/ui';
import styled from 'styled-components';
import { DropdownTriggerButton } from '../../dropdown/trigger-button';
import { FontAwesomeIcon } from '../../icon/icon';

export const ToolbarButton = styled(Button).attrs({
  size: 'small',
})``;
export const ToolbarDropdownTriggerButton = styled(DropdownTriggerButton).attrs(
  {
    size: 'small',
  },
)``;
export const ToolbarButtonIcon = styled(FontAwesomeIcon).attrs({
  size: 12,
})``;
